"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.SubStorage = exports.Storage = void 0;
var _lruCache = _interopRequireDefault(require("lru-cache"));
var _rxjs = require("rxjs");
var _chainListener = require("../chain-listener");
var _error = require("./error");
/**
 * a tool to create same query interfaces for apiPromise and apiRx
 */
class SubStorage {
  constructor(configs) {
    this.configs = void 0;
    this.subject = void 0;
    this.chainListener = void 0;
    this.configs = configs;
    this.subject = new _rxjs.ReplaySubject(1);
    this.chainListener = _chainListener.ChainListener.create({
      api: configs.api
    });
    this.subscribe();
  }
  subscribe() {
    const {
      api
    } = this.configs;
    if (api.type === 'promise') {
      this.subscribeWithPromiseApi();
    }
    if (api.type === 'rxjs') {
      this.subscribeWithRxApi();
    }
    this.triggerByEvents();
  }
  getQuery(api) {
    const {
      path,
      query
    } = this.configs;
    if (query) return query;
    if (path) {
      const queryPath = path.split('.');
      return queryPath.reduce((acc, i) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return acc[i];
      }, api);
    }
    throw new _error.RequiredQueryPathOrQuery();
  }
  triggerByEvents() {
    const {
      events
    } = this.configs;
    if (events) {
      this.chainListener.subscribeByEvents(events).subscribe({
        next: () => this.queryData()
      });
    }
  }
  async queryData() {
    const {
      api,
      params
    } = this.configs;
    const query = await this.getQuery(api);
    if (api.type === 'promise') {
      const data = await query(...params);
      this.subject.next(data);
    }
    if (api.type === 'rxjs') {
      const data = await (0, _rxjs.firstValueFrom)(query(...params));
      this.subject.next(data);
    }
  }
  async subscribeWithPromiseApi() {
    const {
      at,
      params
    } = this.configs;
    let api = this.configs.api;
    if (at) {
      const blockHash = await api.rpc.chain.getBlockHash(at);
      api = await api.at(blockHash);
    }
    params.push(result => this.subject.next(result));
    const func = this.getQuery(api);
    if (!func) return;
    func(...params);
  }
  async subscribeWithRxApi() {
    const {
      at,
      params
    } = this.configs;
    let api = this.configs.api;
    if (at) {
      const blockHash = await (0, _rxjs.firstValueFrom)(api.rpc.chain.getBlockHash(at));
      api = await api.at(blockHash);
      const func = this.getQuery(api);
      if (!func) return;

      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
      const storage$ = func(...params);
      if ((0, _rxjs.isObservable)(storage$)) {
        storage$.pipe((0, _rxjs.tap)(result => this.subject.next(result))).subscribe();
      }
    }
    api.isReady.subscribe(() => {
      const func = this.getQuery(api);
      if (!func) return;

      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
      const storage$ = func.call(api, ...params);
      if ((0, _rxjs.isObservable)(storage$)) {
        storage$.pipe((0, _rxjs.tap)(result => this.subject.next(result))).subscribe();
      }
    });
  }
  get observable() {
    return this.subject.asObservable();
  }
  async query() {
    return (0, _rxjs.firstValueFrom)(this.observable);
  }
  complated() {
    this.subject.complete();
  }
}
exports.SubStorage = SubStorage;
function getSubStorageKey(configs) {
  const {
    api,
    path,
    query,
    params
  } = configs;
  if (query) {
    return [api.runtimeChain.toString(), api.type,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    query.section,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    query.method, JSON.stringify(params)].join(',');
  }
  return [api.runtimeChain.toString(), api.type, path,
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  JSON.stringify(params)].join('-');
}
class Storage {
  static create(configs) {
    const key = getSubStorageKey(configs);
    if (this.subStorages.has(key)) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const cached = this.subStorages.get(key);
      if (cached.configs.api.isConnected) return cached;
    }
    const subStorage = new SubStorage(configs);
    this.subStorages.set(key, subStorage);
    return subStorage;
  }
}
exports.Storage = Storage;
Storage.subStorages = new _lruCache.default({
  max: 5000
});